module.exports = __webpack_public_path__ + "img/sign-success.5104e354.png";